import { AxiosResponse } from "axios";
import SecureClient from "../SecureClient";
import { EventListenerLogEntry, EventListenerLogFilter } from "./DTO";

export default class EventListenerLogClient extends SecureClient {
	public getEventListenerLog = (filter: EventListenerLogFilter): Promise<AxiosResponse<EventListenerLogEntry[]>> => {
		return this._api.get<EventListenerLogEntry[]>(`EventListenerLog`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader(),
				...this.contentTypeHeader()
			},
			paramsSerializer: (v) => {
				const urlSearchParams = new URLSearchParams();
				for (const [key, value] of Object.entries(v)) {

					// do not set this to !value - it fails if the value is 0
					if (value === null || value === undefined)
						continue;


					if (Array.isArray(value)) {
						for (const item of value) {
							// same as above with !item 
							if (item === null || item === undefined)
								continue;

							urlSearchParams.append(key, item.toString())
						}
					} else {
						urlSearchParams.append(key, (value as string ?? '').toString())
					}
				}

				return urlSearchParams.toString()
			},
			params: {
				eventId: filter.eventId,
				eventListenerId: filter.eventListenerId,
				logLevel: filter.logLevel,
				eventDateFrom: filter.eventDateFrom,
				eventDateTo: filter.eventDateTo,
				pageNumber: filter.pageNumber,
				pageSize: filter.pageSize,
				sortBy: filter.sortBy
			}
		})
	}

	public getEventListenerLogCount = (filter: EventListenerLogFilter): Promise<AxiosResponse<number>> => {
		return this._api.get<number>(`EventListenerLog/Count`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader(),
				...this.contentTypeHeader()
			},
			paramsSerializer: (v) => {
				const urlSearchParams = new URLSearchParams();
				for (const [key, value] of Object.entries(v)) {

					if (value === null || value === undefined)
						continue;

					if (Array.isArray(value)) {
						for (const item of value) {
							if (item === null || item === undefined)
								continue;

							urlSearchParams.append(key, item.toString())
						}
					} else {
						urlSearchParams.append(key, (value as string ?? '').toString())
					}
				}

				return urlSearchParams.toString()
			},
			params: {
				eventId: filter.eventId,
				eventListenerId: filter.eventListenerId,
				logLevel: filter.logLevel,
				eventDateFrom: filter.eventDateFrom,
				eventDateTo: filter.eventDateTo,
				pageNumber: filter.pageNumber,
				pageSize: filter.pageSize,
				sortBy: filter.sortBy
			}
		})
	}


}